import React, { useMemo } from 'react';
import { Box, Typography, Tooltip } from '@mui/material';

// Simple component to truncate text based on maxLength
const TruncatedText = ({
  text,
  onClickHandler = () => {},
  htmlElement = '',
  className = '',
  maxLength = 15,
}) => {
  // Handle null/undefined text
  const originalText = text || '-';

  // Simple truncation based on maxLength
  const { displayText, isTruncated } = useMemo(() => {
    if (originalText.length <= maxLength) {
      return {
        displayText: originalText,
        isTruncated: false,
      };
    }

    return {
      displayText: originalText.substring(0, maxLength) + '...',
      isTruncated: true,
    };
  }, [originalText, maxLength]);

  return (
    <Tooltip title={isTruncated && originalText !== '-' ? originalText : ''} disableInteractive>
      <Box
        className="tempValueWrapper"
        onClick={onClickHandler}
        sx={{
          width: '100%',
          maxWidth: '100%',
        }}
      >
        {htmlElement ? (
          <Box>{htmlElement}</Box>
        ) : (
          <Typography
            className={className}
            sx={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              width: '100%',
            }}
          >
            {displayText}
          </Typography>
        )}
      </Box>
    </Tooltip>
  );
};

export default TruncatedText;
